/* eslint-disable camelcase */
import {
  TAB_STATUS_DONE,
  TAB_STATUS_TODO,
} from '../../../components/ViewControls/CertsControlTabs/constant';
import { httpService } from '../../../http-service/httpService';
// eslint-disable-next-line import/no-cycle
import { getCertDetailsData } from '../core/action';
import { getProgressBreakdownDetails } from '../linearprogressbar/action';
import {
  getTabCounts,
  setCertsTabs,
  setTabHightLightKey,
} from '../tabs/action';
import {
  APPLIED_SAVI_ACITONS_FILTER,
  APPLIED_SAVI_SMART_FILTER,
  APPLY_SAVI_COMPANION_ACTIONS_FAILURE,
  APPLY_SAVI_COMPANION_ACTIONS_LOAD,
  APPLY_SAVI_COMPANION_ACTIONS_SUCCESS,
  CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS,
  CLEAR_SAVI_ACTIONS_FILTER,
  GET_SAVI_COMPANION_STATUS_FAILURE,
  GET_SAVI_COMPANION_STATUS_LOAD,
  GET_SAVI_COMPANION_STATUS_SUCCESS,
  SET_IS_CERTIFICATE_ACTIONABLE,
  SET_IS_SAVI_COMPANION_ENABLED,
  SET_IS_SAVI_FILTER_APPLIED,
} from '../types';
import { URL_SAVI_APPLY_API, URL_SAVI_STATUS_API } from '../urls';

export const setIsSaviApplied = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_SAVI_FILTER_APPLIED,
    payload: status,
  });
};

export const setIsSaviEnabled = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_SAVI_COMPANION_ENABLED,
    payload: status,
  });
};

export const clearSaviActionsFilterAction = (flag) => (dispatch) =>
  dispatch({
    type: CLEAR_SAVI_ACTIONS_FILTER,
    payload: flag,
  });

export const appliedSaviActionFilter = (payload) => (dispatch) => {
  dispatch({
    type: APPLIED_SAVI_ACITONS_FILTER,
    payload,
  });
};

export const setIsCertificationActionable = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_CERTIFICATE_ACTIONABLE,
    payload: status,
  });
};

export const setTriggerFromApplyActions = (flag) => (dispatch) =>
  dispatch({
    type: CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS,
    payload: flag,
  });

export const appliedSaviSmartFilter = (payload) => (dispatch) => {
  dispatch({
    type: APPLIED_SAVI_SMART_FILTER,
    payload,
  });
};

export const getSaviCompanionStatus =
  (certkey, postFailureAction, retryAction) => async (dispatch) => {
    try {
      // Set loading status to true
      dispatch({ type: GET_SAVI_COMPANION_STATUS_LOAD, payload: true });

      const { data } = await httpService.post(URL_SAVI_STATUS_API, {
        certkey,
        signal: 'TRUST_SCORE',
      });

      dispatch({
        type: GET_SAVI_COMPANION_STATUS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      postFailureAction({
        title: 'There was a problem loading Smart Decisions.',
        retryAction,
      });
      dispatch({ type: GET_SAVI_COMPANION_STATUS_FAILURE, payload: false });
    }
  };

const TabDecision = {
  0: TAB_STATUS_TODO,
  1: TAB_STATUS_DONE,
  2: TAB_STATUS_DONE,
};

const isDecidedTabDoneTab = (tabKey, decidedTab) =>
  tabKey === TAB_STATUS_DONE && tabKey === decidedTab;

export const applySaviCompanionActions =
  (payload, config) => async (dispatch) => {
    const {
      columnNames,
      max,
      offset,
      postSuccessAction,
      postFailureAction,
      tabData,
    } = config;

    try {
      dispatch({ type: APPLY_SAVI_COMPANION_ACTIONS_LOAD, payload: true });

      const { approve_overwrite, reject_overwrite, savi_approve, savi_reject } =
        payload;

      await httpService.post(URL_SAVI_APPLY_API, {
        ...payload,
        approve_overwrite:
          approve_overwrite !== undefined
            ? `${approve_overwrite}`
            : approve_overwrite,
        reject_overwrite:
          reject_overwrite !== undefined
            ? `${reject_overwrite}`
            : reject_overwrite,
        savi_approve:
          savi_approve !== undefined ? `${savi_approve}` : savi_approve,
        savi_reject: savi_reject !== undefined ? `${savi_reject}` : savi_reject,
      });
      dispatch(getTabCounts(payload.certkey));
      dispatch(getProgressBreakdownDetails(payload.certkey, 'decision', true));
      const decidedTab = TabDecision[(savi_approve || 0) + (savi_reject || 0)];

      const isHighlightedTab = tabData.map((tab) => ({
        ...tab,
        isHighlighted: tab.key === decidedTab,
        showSaviPopupTab: isDecidedTabDoneTab(tab.key, decidedTab),
      }));

      dispatch(setCertsTabs(isHighlightedTab));
      dispatch(setTriggerFromApplyActions(true));
      dispatch(getCertDetailsData(payload.certkey, columnNames, max, offset));
      postSuccessAction();
      dispatch(setTabHightLightKey(decidedTab));
      dispatch({
        type: APPLY_SAVI_COMPANION_ACTIONS_SUCCESS,
        payload,
      });
    } catch (err) {
      postFailureAction({
        title: 'There was a problem loading Smart Decisions.',
        retryAction: config.retryAction,
      });
      dispatch({ type: APPLY_SAVI_COMPANION_ACTIONS_FAILURE, payload: false });
    }
  };
